import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import TailwindLayout from 'TailwindcssComponents/TailwindLayout';
import TopBar from 'TailwindcssComponents/TopBar';
import DataTable from 'TailwindcssComponents/Tables';
import axios from 'axios';
import FooterTailwind from 'TailwindcssComponents/Footer';
import { ToastContainer, toast } from 'react-toastify';
import { UserDataContext } from 'context';
import PermissionModel from './Models/permissionModel';
import EditCustomUserRoleModel from './Models/editCustomUserRoleModel';

export default function ViewUserRoles() {
    const apiUrl = process.env.REACT_APP_API_BASE_URL;
    const bearerToken = localStorage.getItem('token');
    const { userData, selectedOrganization } = useContext(UserDataContext);
    const userRole = userData?.isAdmin ? 'admin' : selectedOrganization?.name || 'user';
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const [userRoles, setUserRoles] = useState([]);
    const [selectedPermissionId, setSelectedPermissionId] = useState(null);
    const [selectedUserRoleId, setSelectedUserRoleId] = useState(null);
    const [openModel, setOpenModel] = useState();
    const [searchTerm, setSearchTerm] = useState('');
    const [totalItemsCount, setTotalItemsCount] = useState(0);
    const [totalPagesCount, setTotalPagesCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [filteredUserRoles, setFilteredUserRoles] = useState([]);

    const fetchUserRoles = async () => {
        try {
            setIsLoading(true);
            const response = await axios.get(`${apiUrl}auth-service/user-role`,
                {
                    params: { page: currentPage, limit: rowsPerPage, name: searchTerm },
                    headers: { 'Authorization': `Bearer ${bearerToken}` }
                },
            );
            if (response.data?.success) {
                setUserRoles(response.data.data);
                setFilteredUserRoles(response.data.data);
                setTotalItemsCount(response.data.totalItems || 0);
                setTotalPagesCount(response.data.totalPages || 0);
                setTotalPagesCount(response.data.totalPages || 0);
            } else throw new Error(response.data?.message || 'Error in fetching userRoles');
        } catch (error) {
            console.error(error.response?.data?.message || error.message);
        } finally {
            setIsLoading(false);
        }
    };

    const handleActionClick = (id, action) => {
        if (action === 'edit') {
            handleOpenModel(id);
        }
        else if (action === 'delete') {
            handleDelete(id);
        }
    };

    const filterCategory = (term) => {
        if (!term) {
            setFilteredUserRoles(userRoles); // Reset to all data if search term is empty
            return;
        }
        const lowerCaseTerm = term.toLowerCase();
        const filtered = userRoles.filter((event) =>
            event.name.toLowerCase().includes(lowerCaseTerm) // Filter by name
            // event.slug?.toLowerCase().includes(lowerCaseTerm) // Optional: Filter by description
        );
        setFilteredUserRoles(filtered);
    };

    const handleSearch = (term) => {
        setSearchTerm(term);
        filterCategory(term);
    };

    useEffect(() => {
        fetchUserRoles();
    }, [bearerToken, currentPage, rowsPerPage, searchTerm]);

    const formattedDate = (date) => {
        const options = { day: '2-digit', month: 'short', year: 'numeric' };
        return new Date(date).toLocaleDateString('en-GB', options);
    };

    const columns = [
        {
            key: 'name', label: 'User Role',
            render: (row) => (row.name),
        },
        { key: 'createdAt', label: 'Created Date', render: (row) => formattedDate(row.createdAt) },
    ];

    const handleOpenModel = (id) => {
        setSelectedUserRoleId(typeof id === 'string' || typeof id === 'number' ? id : null);
        setOpenModel(true);
    }

    const handleCloseModel = () => {
        setOpenModel(false);
        fetchUserRoles();
    };

    return (
        <TailwindLayout>
            <TopBar />
            <div className="p-12 bg-gray-100 min-h-screen">
                <DataTable
                    title={'User Roles'}
                    rows={filteredUserRoles} columns={columns}
                    onActionClick={handleActionClick}
                    options={{ showHeader: false, showHeaderTwo: true, viewOption: false, editOption: true, addOption: true, statusFilterOption: false, dateFilterOption: false, typeFilterOption: false, searchOption: true }}
                    handleDialogBoxes={() => navigate("/userRoles/invite-userRoles")}
                    totalCount={totalItemsCount}
                    pagesCount={totalPagesCount}
                    currentPage={currentPage}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={(limit) => setRowsPerPage(limit)}
                    onPageChange={(page) => setCurrentPage(page)}
                    // eventStatus={eventStatus}
                    // onStatusChange={(status) => setEventStatus(status)}
                    // categories={eventCategories}
                    // onCategoryChange={(id) => setSelectedPermissionId(id)}
                    // category={selectedCategoryName}
                    // onDateChange={(date) => setSelectedDate(date)}
                    // filteredDate={selectedDate}
                    onSearch={handleSearch}
                    searcItem={searchTerm}
                    role={userRole}
                    loaderStatus={isLoading}
                    addButtonTitle={'Invite User'}
                />
            </div>
            <EditCustomUserRoleModel
                open={openModel}
                onClose={handleCloseModel}
                roleId={selectedUserRoleId}
            />
            <ToastContainer
                position="bottom-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
            <FooterTailwind />
        </TailwindLayout>
    )
}